export default __webpack_public_path__ + "static/WifiInEveryRoom-3d6c028e7363c76683a6f6c32654c2c4.jpg";